import React from "react";
import PropTypes from "prop-types";
import formField from "../formField";

export function FileInput({ input, multiple = false }) {
  const onChange = e => {
    const [...files] = e.target.files;
    if (multiple) {
      input.onChange(files || null);
      input.onBlur(files || null);
      return;
    }
    input.onChange(files[0] || null);
    input.onBlur(files[0] || null);
  };

  const onBlur = e => {
    if (!e.target.value) {
      input.onBlur(null);
    }
  };

  return (
    <input
      type="file"
      id={input.name}
      className="form-control"
      onChange={onChange}
      onBlur={onBlur}
      multiple={multiple}
    />
  );
}

export default formField(FileInput);

FileInput.propTypes = {
  input: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  multiple: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/FileInput/FileInput.jsx